import axios from 'axios'
import qs from 'qs'

export async function reportPrivateMessage (messageId: number, reason: string) {
  const { data } = await axios.post('/inbox/report', qs.stringify({
    reportedMessageId: messageId,
    reason
  }))
  return data
}
